export const seoTranslations: Record<string, Record<string, string>> = {
  en: {
    meta_title_home: "Free Barcode Generator Online — EAN, UPC, Code 128",
    meta_desc_home: "Create barcodes online for free: EAN-13, UPC, Code 128, Code 39. Download the barcode in SVG for printing and labels.",
    h1_title: "Free Barcode Generator Online",
    h1_desc: "Create barcodes online for free: EAN-13, UPC, Code 128, Code 39 and other formats. Download your barcode in SVG for printing and labels.",
    meta_title_terms: "Terms of Use - Free Barcode Generator",
    meta_desc_terms: "Read our Terms of Use to understand the rules and guidelines for our free online barcode generator service.",
    meta_title_privacy: "Privacy Policy - Free Barcode Generator",
    meta_desc_privacy: "Learn about our data security. We generate barcodes completely client-side in your browser.",
    meta_title_mobile: "Barcode Scanner App for Android & iOS",
    meta_desc_mobile: "Take our barcode generator everywhere. Our mobile app for Android and iOS is coming soon.",
    meta_title_contacts: "Contact Us - Free Barcode Generator",
    meta_desc_contacts: "Get in touch with the team behind Free Barcode Generator online.",
    meta_title_sitemap: "Site Map - Free Barcode Generator",
    meta_desc_sitemap: "Explore all pages and language versions of the Free Barcode Generator."
  },
  ru: {
    meta_title_home: "Бесплатный Генератор Штрихкодов Онлайн — EAN, UPC",
    meta_desc_home: "Создайте штрихкод онлайн бесплатно: EAN-13, UPC, Code 128. Скачайте штрихкод в SVG для этикеток.",
    h1_title: "Бесплатный Генератор Штрихкодов Онлайн",
    h1_desc: "Создайте штрихкод онлайн бесплатно: EAN-13, UPC-A, Code 128 и другие форматы. Скачайте в SVG для печати.",
    meta_title_terms: "Условия использования - Генератор штрихкодов",
    meta_desc_terms: "Ознакомьтесь с Условиями использования сервиса.",
    meta_title_privacy: "Политика конфиденциальности - Генератор штрихкодов",
    meta_desc_privacy: "Узнайте о безопасности данных. Штрихкоды генерируются в вашем браузере.",
    meta_title_mobile: "Приложение Сканер Штрихкодов (Android, iOS)",
    meta_desc_mobile: "Мобильное приложение для штрихкодов скоро будет доступно.",
    meta_title_contacts: "Контакты - Генератор штрихкодов",
    meta_desc_contacts: "Свяжитесь с командой генератора штрихкодов.",
    meta_title_sitemap: "Карта сайта - Генератор штрихкодов",
    meta_desc_sitemap: "Изучите все страницы генератора штрихкодов."
  },
  pt: {
    meta_title_home: "Gerador de Código de Barras Online Grátis — EAN, UPC",
    meta_desc_home: "Crie códigos de barras online grátis: EAN-13, UPC, Code 128. Baixe em SVG para impressão.",
    h1_title: "Gerador de Código de Barras Online Grátis",
    h1_desc: "Crie códigos de barras online grátis: EAN-13, UPC, Code 128 e mais formatos. Baixe em SVG para etiquetas.",
    meta_title_terms: "Termos de Uso",
    meta_desc_terms: "Leia nossos Termos de Uso do nosso serviço de gerador de código de barras online grátis.",
    meta_title_privacy: "Política de Privacidade",
    meta_desc_privacy: "Geramos códigos de barras do lado do cliente no seu navegador, prezamos pela segurança.",
    meta_title_mobile: "App Gerador de Código de Barras",
    meta_desc_mobile: "No nosso app você terá suas ferramentas de código de barras em qualquer lugar.",
    meta_title_contacts: "Contatos",
    meta_desc_contacts: "Entre em contato com nossa equipe.",
    meta_title_sitemap: "Mapa do Site",
    meta_desc_sitemap: "Explore as páginas em todos os idiomas."
  },
  es: {
    meta_title_home: "Generador de Códigos de Barras Gratis Online",
    meta_desc_home: "Cree códigos de barras online gratis: EAN-13, UPC, Code 128. Descargue en formato SVG.",
    h1_title: "Generador de Códigos de Barras Online Gratis",
    h1_desc: "Cree códigos de barras online gratis: EAN, UPC, Code 128 y otros. Descargue su código en SVG para imprimir.",
    meta_title_terms: "Términos de uso",
    meta_desc_terms: "Lea nuestros términos de uso sobre el generador de códigos de barras.",
    meta_title_privacy: "Política de privacidad",
    meta_desc_privacy: "Conozca cómo protegemos sus datos generando códigos de lado del cliente.",
    meta_title_mobile: "App Generador de Códigos de Barras",
    meta_desc_mobile: "Lleve sus códigos a cualquier parte con nuestra App pronto disponible.",
    meta_title_contacts: "Contactos",
    meta_desc_contacts: "Contacte con el equipo de Free Barcode Generator.",
    meta_title_sitemap: "Mapa del sitio",
    meta_desc_sitemap: "Explore todas las versiones idiomáticas de nuestra herramienta."
  },
  fr: {
    meta_title_home: "Générateur de Code-Barres en Ligne Gratuit",
    meta_desc_home: "Créez des codes-barres gratuits en ligne : EAN-13, UPC, Code 128. Téléchargez en SVG.",
    h1_title: "Générateur de Code-Barres Gratuit en Ligne",
    h1_desc: "Créez vos codes-barres gratuits : EAN-13, UPC, Code 128. Téléchargez en format SVG pour impression et étiquettes.",
    meta_title_terms: "Conditions d'utilisation",
    meta_desc_terms: "Lisez nos conditions générales pour utiliser notre convertisseur en ligne.",
    meta_title_privacy: "Politique de confidentialité",
    meta_desc_privacy: "Les données sont traitées dans le navigateur. Lisez notre politique de confidentialité.",
    meta_title_mobile: "AppGénérateur de Code-Barres",
    meta_desc_mobile: "Découvrez bientôt notre application sur Android et iOS.",
    meta_title_contacts: "Contacts",
    meta_desc_contacts: "Contactez l'équipe du générateur de code-barres.",
    meta_title_sitemap: "Plan du site",
    meta_desc_sitemap: "Explorez notre générateur et ses traductions."
  },
  de: {
    meta_title_home: "Kostenloser Barcode-Generator Online",
    meta_desc_home: "Erstellen Sie online kostenlose Barcodes: EAN-13, UPC, Code 128. SVG herunterladen.",
    h1_title: "Kostenloser Online Barcode-Generator",
    h1_desc: "Erstellen Sie online kostenlose Barcodes: EAN-13, UPC, Code 128. Laden Sie in SVG für den Etikettendruck herunter.",
    meta_title_terms: "Nutzungsbedingungen",
    meta_desc_terms: "Unsere Nutzungsbedingungen für den kostenlosen Barcode-Generator.",
    meta_title_privacy: "Datenschutzerklärung",
    meta_desc_privacy: "Erfahren Sie mehr über unsere lokalen und sicheren Barcode-Prozesse.",
    meta_title_mobile: "Barcode-Scanner-App",
    meta_desc_mobile: "Unsere mobile App für Android und iOS ist in Kürze verfügbar.",
    meta_title_contacts: "Kontakte",
    meta_desc_contacts: "Nehmen Sie Kontakt mit unserem Barcode-Generator-Team auf.",
    meta_title_sitemap: "Seitenübersicht",
    meta_desc_sitemap: "Erkunden Sie alle Seiten und Sprachversionen."
  },
  it: {
    meta_title_home: "Generatore di Codici a Barre Online Gratis",
    meta_desc_home: "Crea codici a barre online gratis: EAN-13, UPC, Code 128. Scarica in SVG.",
    h1_title: "Generatore di Codici a Barre Online",
    h1_desc: "Crea file di codici a barre: EAN-13, UPC, Code 128. Scarica il codice in formato SVG.",
    meta_title_terms: "Termini di Utilizzo",
    meta_desc_terms: "Termini e Condizioni d'uso per il nostro generatore di codici a barre.",
    meta_title_privacy: "Informativa sulla privacy",
    meta_desc_privacy: "Creiamo codici a barre in modo sicuro, lato client.",
    meta_title_mobile: "App per Codici a Barre",
    meta_desc_mobile: "La nostra applicazione per smartphone Android e iOS (in arrivo).",
    meta_title_contacts: "Contatti",
    meta_desc_contacts: "Resta in contatto con gli sviluppatori.",
    meta_title_sitemap: "Mappa del sito",
    meta_desc_sitemap: "Esplora tutte le pagine relative al generatore online."
  },
  pl: {
    meta_title_home: "Darmowy Generator Kodów Kreskowych Online",
    meta_desc_home: "Twórz kody kreskowe online za darmo: EAN-13, UPC, Code 128. Pobierz w formacie SVG.",
    h1_title: "Darmowy Generator Kodów Kreskowych",
    h1_desc: "Twórz kody kreskowe online za darmo: EAN-13, UPC, Code 128 itd. Pobierz swój kod w SVG.",
    meta_title_terms: "Warunki korzystania",
    meta_desc_terms: "Przeczytaj zasady dla darmowego generatora kodów kreskowych.",
    meta_title_privacy: "Polityka prywatności",
    meta_desc_privacy: "Informacje o zabezpieczeniach generowania kodów u klienta.",
    meta_title_mobile: "Aplikacja generująca kody",
    meta_desc_mobile: "Pobierz naszą aplikację, która wkrótce będzie dostępna dla wszystkich.",
    meta_title_contacts: "Kontakt",
    meta_desc_contacts: "Skontaktuj się z naszym zespołem.",
    meta_title_sitemap: "Mapa strony",
    meta_desc_sitemap: "Zobacz wszystkie dostępne wersje językowe."
  },
  nl: {
    meta_title_home: "Gratis Online Barcode Generator",
    meta_desc_home: "Maak gratis online barcodes: EAN-13, UPC, Code 128 en meer. Download SVG.",
    h1_title: "Gratis Barcode Generator Online",
    h1_desc: "Maak gratis online barcodes aan: EAN-13, UPC, Code 128. Download in SVG voor labels.",
    meta_title_terms: "Gebruiksvoorwaarden",
    meta_desc_terms: "Lees onze gebruiksvoorwaarden door.",
    meta_title_privacy: "Privacybeleid",
    meta_desc_privacy: "Leer meer over onze gegevensbeveiliging; lokale verwerking in de browser.",
    meta_title_mobile: "Barcode App",
    meta_desc_mobile: "De mobiele Barcode Generator app komt eraan.",
    meta_title_contacts: "Contact",
    meta_desc_contacts: "Kom in contact met ons.",
    meta_title_sitemap: "Sitemap",
    meta_desc_sitemap: "Vind de specifieke taalversie of pagina."
  },
  tr: {
    meta_title_home: "Ücretsiz Çevrimiçi Barkod Oluşturucu",
    meta_desc_home: "Ücretsiz barkodlar oluşturun: EAN-13, UPC, Code 128. SVG formatında indirin.",
    h1_title: "Çevrimiçi Ücretsiz Barkod Oluşturucu",
    h1_desc: "Ücretsiz barkodlar oluşturun: EAN-13, UPC, Code 128 ve diğer formatlar. SVG indirin.",
    meta_title_terms: "Kullanım Koşulları",
    meta_desc_terms: "Ücretsiz platformumuz için kullanım kuralları.",
    meta_title_privacy: "Gizlilik Politikası",
    meta_desc_privacy: "Barkod üreticimizin gizlilik ilkeleri.",
    meta_title_mobile: "Barkod Mobil Uygulama",
    meta_desc_mobile: "Mobil barkod uygulamamız yolda.",
    meta_title_contacts: "İletişim",
    meta_desc_contacts: "Bizimle iletişime geçin.",
    meta_title_sitemap: "Site Haritası",
    meta_desc_sitemap: "Tüm dil sürümleri."
  },
  ar: {
    meta_title_home: "مولد الرمز الشريطي مجاناً على الإنترنت",
    meta_desc_home: "قم بإنشاء باركود مجاني: EAN-13, UPC, Code 128. تحميل بصيغة SVG",
    h1_title: "مولد الرمز الشريطي مجاناً على الإنترنت",
    h1_desc: "أنشئ باركود مجاني: EAN-13 ، UPC ، رمز 128 والمزيد. قم بالتنزيل بصيغة SVG.",
    meta_title_terms: "شروط الاستخدام",
    meta_desc_terms: "اقرأ شروط استخدام أداة الباركود الخاصة بنا.",
    meta_title_privacy: "سياسة الخصوصية",
    meta_desc_privacy: "تعرف على أمان بياناتك المضمونة عبر المتصفح.",
    meta_title_mobile: "تطبيق الباركود",
    meta_desc_mobile: "تطبيق التليفون المحمول قريباً.",
    meta_title_contacts: "اتصل بنا",
    meta_desc_contacts: "تواصل مع فريقنا.",
    meta_title_sitemap: "خريطة الموقع",
    meta_desc_sitemap: "تصفح جميع الصفحات واللغات."
  },
  ja: {
    meta_title_home: "無料のオンラインバーコードジェネレーター",
    meta_desc_home: "EAN-13、UPC、Code 128などのバーコードを無料で作成。SVGでダウンロード。",
    h1_title: "無料オンラインバーコードジェネレーター",
    h1_desc: "オンラインで無料でバーコードを作成：EAN-13、UPC、コード128およびその他の形式。SVGで保存します。",
    meta_title_terms: "利用規約",
    meta_desc_terms: "当サイトの利用規約について。",
    meta_title_privacy: "プライバシーポリシー",
    meta_desc_privacy: "生成は完全にブラウザ内で行われます。",
    meta_title_mobile: "バーコードアプリ",
    meta_desc_mobile: "iOSやAndroid向けのアプリはまもなくリリース。",
    meta_title_contacts: "連絡先",
    meta_desc_contacts: "無料ツールのサポートについてはこちら。",
    meta_title_sitemap: "サイトマップ",
    meta_desc_sitemap: "全ページと各言語に簡単にアクセス。"
  },
  "zh-cn": {
    meta_title_home: "免费在线条形码生成器 — EAN, UPC, Code 128",
    meta_desc_home: "免费在线创建条形码：EAN-13, UPC, Code 128。以SVG格式下载打印。",
    h1_title: "免费在线条形码生成器",
    h1_desc: "在线免费创建条形码：EAN-13, UPC, Code 128 以及更多格式。下载SVG矢量格式用于打印和标签。",
    meta_title_terms: "使用条款",
    meta_desc_terms: "了解我们关于免费在线条形码生成器的使用条款。",
    meta_title_privacy: "隐私政策",
    meta_desc_privacy: "生成过程均在浏览器完成，确保您的数据安全。",
    meta_title_mobile: "移动应用程序",
    meta_desc_mobile: "我们的Android和iOS应用即将推出。",
    meta_title_contacts: "联系我们",
    meta_desc_contacts: "联系免费条码生成器团队。",
    meta_title_sitemap: "网站地图",
    meta_desc_sitemap: "探索本站所有网页和语言版本。"
  },
  hi: {
    meta_title_home: "मुफ्त ऑनलाइन बारकोड जनरेटर — EAN, UPC",
    meta_desc_home: "ऑनलाइन बारकोड (EAN, UPC, Code 128) जनरेट करें और SVG फॉर्मेट में डाउनलोड करें।",
    h1_title: "मुफ्त ऑनलाइन बारकोड जनरेटर",
    h1_desc: "बारकोड (EAN-13, UPC, Code 128) ऑनलाइन बनाएं। अपने बारकोड को SVG में डाउनलोड करें।",
    meta_title_terms: "उपयोग की शर्तें",
    meta_desc_terms: "बारकोड जनरेटर का उपयोग करने के लिए हमारी शर्तों को पढ़ें।",
    meta_title_privacy: "गोपनीयता नीति",
    meta_desc_privacy: "बारकोड सीधे आपके ब्राउज़र में जनरेट होता है, हम कोई डेटा सुरक्षित नहीं रखते।",
    meta_title_mobile: "मोबाइल ऐप",
    meta_desc_mobile: "हमारा मोबाइल ऐप (Android/iOS) जल्द आ रहा है।",
    meta_title_contacts: "संपर्क करें",
    meta_desc_contacts: "हमारी टीम से संपर्क करें।",
    meta_title_sitemap: "साइट मैप",
    meta_desc_sitemap: "सभी भाषाओं और पेजों का अन्वेषण करें।"
  }
};

export const fallbackTranslations = seoTranslations.en;

export function getSeoTranslations(lang: string) {
  return seoTranslations[lang] || {};
}
